import {Component, Inject} from '@angular/core';
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-layout-commissions',
  templateUrl: './app.layout-commissions.component.html'
})
export class AppLayoutCommissionsComponent {
  displaySidebar: boolean = false;
  
  constructor(@Inject(DOCUMENT) private document: Document) {
    let themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = 'krediya.v2-theme.css';
    }
  }

  toggleSidebar() {
    this.displaySidebar = !this.displaySidebar
  }
}
